<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      
    </div>
    <footer-com></footer-com>
  </div>
</template>
<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

export default {
  name: 'applyMessage',
  data() {
    return {

    }
  },
  components: {
    HeadCom,
    FooterCom
  },
}
</script>
<style lang="less" scoped>

</style>